export default "__VITE_ASSET__ac6ec55f__"